module.exports = __webpack_public_path__ + "img/gebrateneudonohnehintergrund.4ef53f60.png";